import request from '@/utils/request'

let TansferApi = {
  /*赠送列表*/
  getTransferList(data) {
    return request._post('/shop/plus.transfer.transfer/index', data);
  },
  /*添加赠送记录*/
  addTransfer(data) {
    return request._post('/shop/plus.transfer.transfer/add', data);
  },
  /*删除赠送记录*/
  deleteArticle(data) {
    return request._post('/shop/plus.transfer.transfer/delete', data);
  },
  editArticle(data) {
    return request._post('/shop/plus.transfer.transfer/edit', data);
  },
  /*文章详情*/
  toEditTransfer(data) {
    return request._get('/shop/plus.transfer.transfer/edit', data);
  },


}
export default TansferApi;



// WEBPACK FOOTER //
// ./src/api/transfer.js